module.exports = __webpack_public_path__ + "static/canal-po-whatsapp-2081d3c178d34f596549433f6aef1cf7.jpg";